module.exports = __webpack_public_path__ + "img/image_body-point_02_02.6c19e8cc.svg";